/* eslint-disable camelcase */

import { makeAutoObservable, observe, set, toJS } from 'mobx'

class Email {
  id = 0
  code = ''
  subject = ''
  message = ''
  status = ''
  has_entry = false

  created = null
  modified = null

  _isDirty = false

  _fieldToSave = [
    'code',
    'message',
    'subject'
  ]

  get isDirty () {
    return this._isDirty || !!Object.keys(this).filter(key => {
      return this[key] && this[key]._isDirty !== undefined && this[key].isDirty
    }).length
  }

  resetDirty () {
    this._isDirty = false

    for (const key of Object.keys(this)) {
      if (this[key] && this[key]._isDirty !== undefined) {
        this[key].resetDirty()
      }
    }
    const observeMe = observe(this, () => {
      this._isDirty = true
      // Kill the watcher
      observeMe()
    })
  }

  constructor (data) {
    makeAutoObservable(this)
    if (data) {
      set(this, data)
      const observeMe = observe(this, () => {
        this._isDirty = true
        // Kill the watcher
        observeMe()
      })
    }
  }

  toJson () {
    const email = {}
    for (const props of this._fieldToSave) {
      email[props] = toJS(this[props])
    }
    return email
  }
}

export default Email
